const changeIntakeInfo = (key, value) => {
  return {
    type: 'CHANGE_INTAKE_INFO',
    key,
    value
  }
}

export default changeIntakeInfo;